import { AbstractCommand } from 'src/models/command';

class RestoreTheSelectedAggregateIdsCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_RestoreTheSelectedAggregateIds';

	public constructor(aggregateIds: string[]) {
		super();
		this.parameters = {
			aggregateIds: aggregateIds,
		};
	}
}

export { RestoreTheSelectedAggregateIdsCommand };
